import { enumBranchStyle } from "../constants";
import { IsMultiColumnStyle } from "./IsMultiColumnStyle";
import { IsRightStyle } from "./IsRightStyle";
import { IsLeftStyle } from "./IsLeftStyle";
import { IsPeerStyle } from "./IsPeerStyle";

export function ValidPeerSub(parentBox, subBranchStyle) {
  var peerStyle = IsPeerStyle(subBranchStyle);
  if (!peerStyle) return true;

  if (parentBox) {
    var bStyle = parentBox.GetBranchStyle();
    if (bStyle == enumBranchStyle.tree) return true;
    if (IsMultiColumnStyle(bStyle)) return false;
    if (IsRightStyle(bStyle)) {
      if (subBranchStyle == enumBranchStyle.assistantpeerleft) return false;
    }
    if (IsLeftStyle(bStyle)) {
      if (subBranchStyle == enumBranchStyle.assistantpeerright) return false;
    }
  }

  return true;
}
